import {
  Avatar,
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import { useMutation } from "@apollo/client";
//Import from project
import "./menu.scss";
import CamFlag from "../../Assets/Cambodia.png";
import EngFlag from "../../Assets/United_Kingdom.png";
import RomdoulImage from "../../Assets/hydrangea.png";
import logoSystem from "../../Assets/logoSystem.png";
import { AuthContext } from "../../Context/AuthContext";
import LogoutMenu from "./LogoutMenu";
import { hasPermission } from "../../Context/Permission";
import useWithDimension from "../../Hooks/useWithDimension";
import { AUTO_CHECK_COMPLETE_CLASS_AS_MONTH } from "../../Schema/Dashboard";

export const Menu = () => {
  const { width } = useWithDimension();
  const navigate = useNavigate();
  let location = useLocation();
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  const [checkUpdate, setCheckUpdate] = useState(false);

  const [autoCheckCompleteClass] = useMutation(
    AUTO_CHECK_COMPLETE_CLASS_AS_MONTH,
    {
      // onCompleted: ({ autoCheckCompleteClass }) => {
      //   console.log("autoCheckCompleteClass:", autoCheckCompleteClass);
      // },
      onError: (err) => {
        console.log("Error:", err.message);
      },
    },
  );

  // console.log("loading::", loading)

  const handleUpdateData = async () => {
    setCheckUpdate(true);
    window.location.reload();
    try {
      await autoCheckCompleteClass();
      // const result = await autoCheckCompleteClass();
      // console.log("result:", result?.data?.autoCheckCompleteClass);
    } catch (error) {
      console.log(error);
    } finally {
      setCheckUpdate(false);
    }
  };

  // console.log("userLogin::", userLogin);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // ========================= Change Language ============================
  const { language, changeLanguage, t } = useContext(AuthContext);

  const classNameMenu = (path) => {
    if (language === "en")
      return path.includes(location.pathname) ? "btn-item-active" : "btn-item";
    else
      return path.includes(location.pathname)
        ? "btn-item-active-kh"
        : "btn-item-kh";
  };

  // const handleLogout = () => {
  //   navigate("/");
  //   window.location.reload(true);
  //   window.localStorage.removeItem("token");
  // };

  return (
    <Box className="menu">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Button onClick={() => navigate("/")} className="btn-logo">
            <img src={logoSystem} alt="logo" style={{ height: "50px" }} />
          </Button>

          {width > 1320 && (
            <Stack direction="column" spacing={0}>
              <Stack direction="row" spacing={1}>
                <Typography
                  className={language === "en" ? "welcome" : "welcome-kh"}
                >
                  {t("thead_welcome")}
                </Typography>
                <img alt="Romdoul" src={RomdoulImage} className="romdoul-img" />
              </Stack>
              <Typography
                className={
                  language === "en" ? "company-name" : "company-name-kh"
                }
              >
                {t("thead_siem_reap_music_academy")}
              </Typography>
            </Stack>
          )}
        </Stack>

        {hasPermission(userLogin?.user?.role, "view:menu") && (
          <Stack direction="row" className="btn-menu">
            <Button
              onClick={() => navigate("/dashboard")}
              className={classNameMenu(["/dashboard"])}
            >
              {t("page_dashboard")}
            </Button>

            <Button
              onClick={() => navigate("/student")}
              className={classNameMenu([
                "/student",
                "/student/student-detail",
                "/student/student-enrollment",
                "/student/student-detail/student-class-detail",
              ])}
            >
              {t("page_student")}
            </Button>

            <Button
              onClick={() => navigate("/teacher")}
              className={classNameMenu([
                "/teacher",
                "/teacher/teacher-detail",
                "/teacher/teacher-detail/class-detail",
              ])}
            >
              {t("page_teacher")}
            </Button>

            <Button
              onClick={() => navigate("/class")}
              className={classNameMenu([
                "/class",
                "/class/class-detail",
                "/class/class-detail/student-detail",
              ])}
            >
              {t("page_class")}
            </Button>

            <Button
              onClick={() => navigate("/invoice")}
              className={classNameMenu(["/invoice"])}
            >
              {t("page_invoice")}
            </Button>

            <Button
              onClick={() => navigate("/other")}
              // className={classNameMenu(["/other"])}
              className={classNameMenu([
                "/other",
                "/other/expense",
                "/other/report",
                "/other/lesson",
                "/other/content",
                "/other/package_price",
                "/other/option_price_name",
                "/content/lesson",
              ])}
            >
              {t("page_other")}
            </Button>

            {/* <Button
              onClick={() => navigate("/report")}
              className={classNameMenu(["/report"])}
            >
              {t("page_report")}
            </Button> */}
          </Stack>
        )}

        <Stack direction="row" alignItems="center" spacing={1}>
          {hasPermission(userLogin?.user?.role, "view:menu") && (
            <Stack direction="row" alignItems="center" justifyContent="center">
              <Button
                onClick={handleUpdateData}
                className={checkUpdate ? "btn-update-active" : "btn-update"}
                startIcon={<FlipCameraAndroidIcon />}
              >
                {checkUpdate ? t("loading") : t("update_data")}
              </Button>
            </Stack>
          )}

          {/* ========= Language ======== */}
          <Stack
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
            }}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            {language === "en" ? (
              <Tooltip title="Change to Khmer" placement="left">
                <IconButton
                  onClick={() => changeLanguage("kh")}
                  sx={{ padding: "2px !important" }}
                >
                  <Avatar
                    src={EngFlag}
                    sx={{ width: "35px", height: "35px" }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Change to English" placement="left">
                <IconButton
                  onClick={() => changeLanguage("en")}
                  sx={{ padding: "2px !important" }}
                >
                  <Avatar
                    src={CamFlag}
                    sx={{ width: "35px", height: "35px" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          {hasPermission(userLogin?.user?.role, "view:setting") ||
          userLogin?.user?._id === "6a35180771962a1bcdc6d96e" ? (
            <Stack
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
              }}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <Tooltip title={t("page_setting")} placement="left" arrow>
                <IconButton
                  onClick={() => navigate("/setting")}
                  sx={{
                    bgcolor: [
                      "/setting",
                      "/setting/user",
                      "/setting/class",
                      "/setting/subject",
                      "/setting/shift",
                      "/setting/group-fee",
                      "/setting/course",
                      "/setting/exam-type",
                      "/setting/performance-type",
                      "/setting/expense-type",
                      "/setting/user-action",
                      "/setting/online-book",
                      "/setting/book-content",
                    ].includes(location.pathname)
                      ? "#131870 !important"
                      : "white",
                  }}
                >
                  <SettingsIcon
                    sx={{
                      color: [
                        "/setting",
                        "/setting/user",
                        "/setting/class",
                        "/setting/shift",
                        "/setting/subject",
                        "/setting/course",
                        "/setting/exam-type",
                        "/setting/group-fee",
                        "/setting/performance-type",
                        "/setting/expense-type",
                        "/setting/user-action",
                        "/setting/online-book",
                        "/setting/book-content",
                      ].includes(location.pathname)
                        ? "white"
                        : "#131870",
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Stack>
          ) : (
            ""
          )}

          <Stack
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
            }}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <IconButton
              onClick={handleOpen}
              id="basic-menu"
              sx={{ padding: "2px !important" }}
            >
              <Avatar
                src={userLogin?.user?.profile}
                sx={{ width: "40px", height: "40px" }}
              />
            </IconButton>

            {open && (
              <LogoutMenu
                open={open}
                handleClose={handleClose}
                anchorEl={anchorEl}
              />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
